var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-20" },
    [
      _c(
        "van-form",
        {
          ref: "form",
          attrs: { "show-error": false, "error-message-align": "right" },
        },
        [
          _c(
            "van-cell-group",
            [
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "flowNo",
                    expression: "'flowNo'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("flowNo"),
                  rules: _vm.getRules("flowNo"),
                  label: "编号",
                  "input-align": "right",
                  readonly: "",
                },
                model: {
                  value: _vm.formData.flowNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "flowNo", $$v)
                  },
                  expression: "formData.flowNo",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "dcr",
                    expression: "'dcr'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("dcr"),
                  name: "flowName",
                  label: "订餐人",
                  placeholder: "订餐人",
                  "input-align": "right",
                  rules: _vm.getRules("dcr"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            treeData: _vm.deptUserTreeAll.data,
                            value: _vm.formData.dcr,
                            placeholder: "请选择订餐人",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.deptUserTreeAll, "dcr")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.deptUserTreeAll.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.deptUserTreeAll, "show", $$v)
                              },
                              expression: "deptUserTreeAll.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择订餐人",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.deptUserTreeAll.show = false
                                },
                                "click-right": _vm.handlePopupSubmit,
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.treeSearch($event, _vm.$refs.tree)
                                },
                              },
                              model: {
                                value: _vm.deptUserTreeAll.filterText,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.deptUserTreeAll,
                                    "filterText",
                                    $$v
                                  )
                                },
                                expression: "deptUserTreeAll.filterText",
                              },
                            }),
                            _c(
                              "div",
                              {
                                staticClass: "h-vh-50",
                                staticStyle: { "overflow-y": "auto" },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "p-10" },
                                  [
                                    _c("el-tree", {
                                      ref: "tree",
                                      attrs: {
                                        "node-key": "uuid",
                                        "check-strictly": "",
                                        data: _vm.deptUserTreeAll.data,
                                        "filter-node-method": _vm.filterNode,
                                        "check-on-click-node": "",
                                        "show-checkbox": "",
                                      },
                                      on: {
                                        "check-change": function ($event) {
                                          return _vm.singleChoice(
                                            $event,
                                            _vm.$refs.tree
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.dcr,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "dcr", $$v)
                  },
                  expression: "formData.dcr",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "lxfs",
                    expression: "'lxfs'",
                  },
                ],
                attrs: {
                  readonly: _vm.isDisabled("lxfs"),
                  required: _vm.isRequired("lxfs"),
                  rules: _vm.getRules("lxfs"),
                  name: "lxfs",
                  maxlength: "50",
                  autosize: "",
                  label: "联系方式",
                  placeholder: "请输入联系方式",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.lxfs,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "lxfs", $$v)
                  },
                  expression: "formData.lxfs",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "yclx",
                    expression: "'yclx'",
                  },
                ],
                attrs: {
                  center: "",
                  "input-align": "right",
                  required: _vm.isRequired("yclx"),
                  name: "yclx",
                  rules: _vm.getRules("yclx"),
                  label: "用餐时间",
                  placeholder: "用餐时间",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _vm.isDisabled("yclx")
                          ? _c("view-item", {
                              attrs: {
                                value: _vm.formData.yclx,
                                placeholder: "请选择用餐时间",
                              },
                            })
                          : _c(
                              "van-radio-group",
                              {
                                attrs: { direction: "horizontal" },
                                model: {
                                  value: _vm.formData.yclx,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "yclx", $$v)
                                  },
                                  expression: "formData.yclx",
                                },
                              },
                              [
                                _c("van-radio", { attrs: { name: "午餐" } }, [
                                  _vm._v("午餐"),
                                ]),
                                _c("van-radio", { attrs: { name: "晚餐" } }, [
                                  _vm._v("晚餐"),
                                ]),
                              ],
                              1
                            ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.yclx,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "yclx", $$v)
                  },
                  expression: "formData.yclx",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ycrq",
                    expression: "'ycrq'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("ycrq"),
                  name: "ycrq",
                  label: "用餐日期",
                  placeholder: "用餐日期",
                  "input-align": "right",
                  rules: _vm.getRules("ycrq"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.ycrq,
                            placeholder: "请选择用餐日期",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.ycrq, "ycrq")
                            },
                          },
                        }),
                        _c("van-calendar", {
                          ref: "ycrq",
                          attrs: {
                            "show-confirm": false,
                            title: "选择用餐日期",
                            "min-date": _vm.ycrq.minDate,
                            "max-date": _vm.ycrq.maxDate,
                          },
                          on: { confirm: _vm.ycrqConfirm },
                          model: {
                            value: _vm.ycrq.show,
                            callback: function ($$v) {
                              _vm.$set(_vm.ycrq, "show", $$v)
                            },
                            expression: "ycrq.show",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.ycrq,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "ycrq", $$v)
                  },
                  expression: "formData.ycrq",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ycdd",
                    expression: "'ycdd'",
                  },
                ],
                attrs: {
                  value: _vm.formData.ycdd[0],
                  required: _vm.isRequired("ycdd"),
                  name: "ycdd",
                  label: "用餐地点",
                  placeholder: "用餐地点",
                  "input-align": "right",
                  rules: _vm.getRules("ycdd"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.isShowPopup(_vm.ycdd, "ycdd")
                              },
                            },
                          },
                          [
                            _vm.formData.ycdd.length > 0
                              ? _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formData.ycdd.length > 1
                                          ? _vm.formData.ycdd[0] + "..."
                                          : _vm.formData.ycdd[0]
                                      ) +
                                      " "
                                  ),
                                ])
                              : _c(
                                  "span",
                                  { staticClass: "cor-B3" },
                                  [
                                    _vm._v(" 请选择用餐地点 "),
                                    _c("van-icon", {
                                      attrs: {
                                        name: "arrow",
                                        color: "#8c8c8c",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                          ]
                        ),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.ycdd.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.ycdd, "show", $$v)
                              },
                              expression: "ycdd.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择用餐地点",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.ycdd.show = false
                                },
                                "click-right": function ($event) {
                                  _vm.ycdd.show = false
                                },
                              },
                            }),
                            _c(
                              "van-checkbox-group",
                              {
                                model: {
                                  value: _vm.formData.ycdd,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "ycdd", $$v)
                                  },
                                  expression: "formData.ycdd",
                                },
                              },
                              [
                                _c(
                                  "van-cell-group",
                                  _vm._l(_vm.ycdd.data, function (item, index) {
                                    return _c("van-cell", {
                                      key: index,
                                      attrs: {
                                        clickable: "",
                                        title: item.dictLabel,
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.handlePopupCheckboxCellToggle(
                                            "checkboxes",
                                            index
                                          )
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "right-icon",
                                            fn: function () {
                                              return [
                                                _c("van-checkbox", {
                                                  ref: "checkboxes",
                                                  refInFor: true,
                                                  attrs: {
                                                    "checked-color": "#FFDA3E",
                                                    name: item.dictLabel,
                                                  },
                                                }),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "dclx",
                    expression: "'dclx'",
                  },
                ],
                attrs: {
                  center: "",
                  "input-align": "right",
                  required: _vm.isRequired("dclx"),
                  name: "dclx",
                  rules: _vm.getRules("dclx"),
                  label: "订餐类型",
                  placeholder: "订餐类型",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _vm.isDisabled("dclx")
                          ? _c("view-item", {
                              attrs: {
                                value: _vm.formData.dclx,
                                placeholder: "请选择订餐类型",
                              },
                            })
                          : _c(
                              "van-radio-group",
                              {
                                attrs: { direction: "horizontal" },
                                model: {
                                  value: _vm.formData.dclx,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "dclx", $$v)
                                  },
                                  expression: "formData.dclx",
                                },
                              },
                              [
                                _c("van-radio", { attrs: { name: "公餐" } }, [
                                  _vm._v("公餐"),
                                ]),
                                _c("van-radio", { attrs: { name: "私餐" } }, [
                                  _vm._v("私餐"),
                                ]),
                              ],
                              1
                            ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.dclx,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "dclx", $$v)
                  },
                  expression: "formData.dclx",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ycrs",
                    expression: "'ycrs'",
                  },
                ],
                attrs: {
                  readonly: _vm.isDisabled("ycrs"),
                  type: "number",
                  required: _vm.isRequired("ycrs"),
                  rules: _vm.getRules("ycrs"),
                  name: "ycrs",
                  maxlength: "50",
                  autosize: "",
                  label: "用餐人数",
                  placeholder: "请输入用餐人数",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.ycrs,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "ycrs", $$v)
                  },
                  expression: "formData.ycrs",
                },
              }),
              _vm.formData.dclx === "公餐"
                ? _c("van-field", {
                    directives: [
                      {
                        name: "f-show",
                        rawName: "v-f-show",
                        value: "ssdw",
                        expression: "'ssdw'",
                      },
                    ],
                    attrs: {
                      "input-align": "right",
                      name: "ssdw",
                      required: _vm.isRequired("ssdw"),
                      value: _vm.formData.ssdw,
                      label: "部门",
                      rules: _vm.getRules("ssdw"),
                      placeholder: "请选择部门",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "input",
                          fn: function () {
                            return [
                              _c("view-item", {
                                attrs: {
                                  value: _vm.formData.ssdw,
                                  placeholder: "请选择部门",
                                },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.isShowPopup(_vm.ssdw, "ssdw")
                                  },
                                },
                              }),
                              _c(
                                "van-popup",
                                {
                                  attrs: { position: "bottom" },
                                  model: {
                                    value: _vm.ssdw.show,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ssdw, "show", $$v)
                                    },
                                    expression: "ssdw.show",
                                  },
                                },
                                [
                                  _c("van-nav-bar", {
                                    attrs: {
                                      title: "选择部门",
                                      "left-text": "取消",
                                      "right-text": "确定",
                                    },
                                    on: {
                                      "click-left": function ($event) {
                                        _vm.ssdw.show = false
                                      },
                                      "click-right": function ($event) {
                                        return _vm.popupSubmit("ssdw", {
                                          label: "label",
                                          value: "value",
                                        })
                                      },
                                    },
                                  }),
                                  _c("van-search", {
                                    attrs: { clearable: "", shape: "round" },
                                    on: {
                                      input: function ($event) {
                                        return _vm.pickerSearch(
                                          $event,
                                          _vm.ssdw,
                                          "label"
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.ssdw.filterText,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ssdw, "filterText", $$v)
                                      },
                                      expression: "ssdw.filterText",
                                    },
                                  }),
                                  _c("van-picker", {
                                    ref: "ssdw",
                                    attrs: {
                                      "value-key": "label",
                                      columns: _vm.ssdw.filteredData,
                                    },
                                    on: {
                                      cancel: function ($event) {
                                        _vm.ssdw.show = false
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      496831825
                    ),
                  })
                : _vm._e(),
              _vm.formData.dclx === "公餐"
                ? _c("van-field", {
                    directives: [
                      {
                        name: "f-show",
                        rawName: "v-f-show",
                        value: "ssxm",
                        expression: "'ssxm'",
                      },
                    ],
                    attrs: {
                      "input-align": "right",
                      name: "ssxm",
                      required: _vm.isRequired("ssxm"),
                      value: _vm.formData.ssxm,
                      rules: _vm.getRules("ssxm"),
                      label: "所属项目",
                      placeholder: "请选择项目",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "input",
                          fn: function () {
                            return [
                              _c("view-item", {
                                attrs: {
                                  value: _vm.formData.ssxm,
                                  placeholder: "请选择项目",
                                },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.isShowPopup(_vm.ssxm, "ssxm")
                                  },
                                },
                              }),
                              _c(
                                "van-popup",
                                {
                                  attrs: { position: "bottom" },
                                  model: {
                                    value: _vm.ssxm.show,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ssxm, "show", $$v)
                                    },
                                    expression: "ssxm.show",
                                  },
                                },
                                [
                                  _c("van-nav-bar", {
                                    attrs: {
                                      title: "选择项目",
                                      "left-text": "取消",
                                      "right-text": "确定",
                                    },
                                    on: {
                                      "click-left": function ($event) {
                                        _vm.ssxm.show = false
                                      },
                                      "click-right": function ($event) {
                                        return _vm.popupSubmitSsxm("ssxm", {
                                          label: "projectName",
                                          value: "projectId",
                                        })
                                      },
                                    },
                                  }),
                                  _c("van-search", {
                                    attrs: { clearable: "", shape: "round" },
                                    on: {
                                      input: function ($event) {
                                        return _vm.pickerSearch(
                                          $event,
                                          _vm.ssxm,
                                          "projectName"
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.ssxm.filterText,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ssxm, "filterText", $$v)
                                      },
                                      expression: "ssxm.filterText",
                                    },
                                  }),
                                  _c("van-picker", {
                                    ref: "ssxm",
                                    attrs: {
                                      duration: 0,
                                      "value-key": "projectName",
                                      columns: _vm.ssxm.filteredData,
                                    },
                                    on: {
                                      cancel: function ($event) {
                                        _vm.ssxm.show = false
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      4008444637
                    ),
                  })
                : _vm._e(),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ycbz",
                    expression: "'ycbz'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "ycbz",
                  required: _vm.isRequired("ycbz"),
                  value: _vm.formData.ycbz,
                  label: "用餐标准",
                  rules: _vm.getRules("ycbz"),
                  placeholder: "请选择用餐标准",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.ycbz,
                            placeholder: "请选择用餐标准",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.ycbz, "ycbz")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.ycbz.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.ycbz, "show", $$v)
                              },
                              expression: "ycbz.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择用餐标准",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.ycbz.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("ycbz")
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.ycbz,
                                    "label"
                                  )
                                },
                              },
                              model: {
                                value: _vm.ycbz.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ycbz, "filterText", $$v)
                                },
                                expression: "ycbz.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "ycbz",
                              attrs: {
                                "value-key": "label",
                                columns: _vm.ycbz.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.ycbz.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "csjb",
                    expression: "'csjb'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "csjb",
                  required: _vm.isRequired("csjb"),
                  value: _vm.formData.csjb,
                  label: "茶水级别",
                  rules: _vm.getRules("csjb"),
                  placeholder: "请选择茶水级别",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.csjb,
                            placeholder: "请选择茶水级别",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.csjb, "csjb")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.csjb.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.csjb, "show", $$v)
                              },
                              expression: "csjb.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择茶水级别",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.csjb.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("csjb")
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.csjb,
                                    "label"
                                  )
                                },
                              },
                              model: {
                                value: _vm.csjb.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.csjb, "filterText", $$v)
                                },
                                expression: "csjb.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "csjb",
                              attrs: {
                                "value-key": "label",
                                columns: _vm.csjb.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.csjb.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _vm.formData.dclx === "公餐"
                ? _c("van-field", {
                    directives: [
                      {
                        name: "f-show",
                        rawName: "v-f-show",
                        value: "sy",
                        expression: "'sy'",
                      },
                    ],
                    attrs: {
                      readonly: _vm.isDisabled("sy"),
                      required: _vm.isRequired("sy"),
                      name: "sy",
                      rules: _vm.getRules("sy"),
                      type: "textarea",
                      maxlength: "200",
                      rows: "3",
                      autosize: "",
                      label: "事由",
                      "show-word-limit": "",
                      placeholder: "请输入事由",
                      "input-align": "right",
                    },
                    model: {
                      value: _vm.formData.sy,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "sy", $$v)
                      },
                      expression: "formData.sy",
                    },
                  })
                : _vm._e(),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "dcbz",
                    expression: "'dcbz'",
                  },
                ],
                attrs: {
                  readonly: _vm.isDisabled("dcbz"),
                  required: _vm.isRequired("dcbz"),
                  name: "dcbz",
                  rules: _vm.getRules("dcbz"),
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "备注",
                  "show-word-limit": "",
                  placeholder: "请输入备注",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.dcbz,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "dcbz", $$v)
                  },
                  expression: "formData.dcbz",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "field1638593529445",
                    expression: "'field1638593529445'",
                  },
                ],
                staticClass: "fileValueBox",
                attrs: {
                  "input-align": "right",
                  name: "field1638593529445",
                  required: _vm.isRequired("field1638593529445"),
                  rules: _vm.getRules("field1638593529445"),
                  label: "附件",
                  placeholder: "请上传文件",
                },
                domProps: { value: _vm.formData.field1638593529445 },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("uploadFiles", {
                          attrs: {
                            disabled: _vm.isDisabled("field1638593529445"),
                            files: _vm.formData.field1638593529445,
                            "module-type": "flow",
                          },
                          on: {
                            success: _vm.uploadSuccess,
                            fileRemove: (removedFile) =>
                              _vm.handleFileRemove(
                                removedFile,
                                "formData",
                                "field1638593529445"
                              ),
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "xfzje",
                    expression: "'xfzje'",
                  },
                ],
                attrs: {
                  readonly: _vm.isDisabled("xfzje"),
                  type: "number",
                  required: _vm.isRequired("xfzje"),
                  rules: _vm.getRules("xfzje"),
                  name: "xfzje",
                  maxlength: "50",
                  autosize: "",
                  label: "消费总金额",
                  placeholder: "请输入消费总金额",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.xfzje,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "xfzje", $$v)
                  },
                  expression: "formData.xfzje",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "sszje",
                    expression: "'sszje'",
                  },
                ],
                attrs: {
                  readonly: _vm.isDisabled("sszje"),
                  type: "number",
                  required: _vm.isRequired("sszje"),
                  rules: _vm.getRules("sszje"),
                  name: "sszje",
                  maxlength: "50",
                  autosize: "",
                  label: "实收总金额",
                  placeholder: "请输入实收总金额",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.sszje,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "sszje", $$v)
                  },
                  expression: "formData.sszje",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "xfmxfj",
                    expression: "'xfmxfj'",
                  },
                ],
                staticClass: "fileValueBox",
                attrs: {
                  "input-align": "right",
                  name: "xfmxfj",
                  required: _vm.isRequired("xfmxfj"),
                  rules: _vm.getRules("xfmxfj"),
                  label: "消费明细附件",
                  placeholder: "请上传文件",
                },
                domProps: { value: _vm.formData.xfmxfj },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("uploadFiles", {
                          attrs: {
                            disabled: _vm.isDisabled("xfmxfj"),
                            files: _vm.formData.xfmxfj,
                            "module-type": "flow",
                          },
                          on: {
                            success: _vm.xfmxfjUploadSuccess,
                            fileRemove: (removedFile) =>
                              _vm.handleFileRemove(
                                removedFile,
                                "formData",
                                "xfmxfj"
                              ),
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "font-32 font-weight-500 cor-00 m-t-26" }, [
        _vm._v("流程"),
      ]),
      !_vm.$route.query.reSend &&
      (_vm.processInstanceId || _vm.$route.query.processInstanceId)
        ? _c("flowTrace", {
            staticClass: "m-t-20",
            attrs: {
              flowTraceList: _vm.flowTrace,
              processInfo: _vm.processData,
            },
          })
        : _c("approver", {
            ref: "approver",
            staticClass: "m-t-20",
            attrs: { processData: _vm.processData, formData: _vm.formData },
            on: { addUser: _vm.addUser },
          }),
      _c("bottom-bar", { on: { submit: _vm.submit, mention: _vm.mention } }),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.approver.show,
            callback: function ($$v) {
              _vm.$set(_vm.approver, "show", $$v)
            },
            expression: "approver.show",
          },
        },
        [
          _c("van-nav-bar", {
            attrs: {
              title: "选择办理人",
              "left-text": "取消",
              "right-text": "确定",
            },
            on: {
              "click-left": function ($event) {
                _vm.approver.show = false
              },
              "click-right": _vm.approverPopupSubmit,
            },
          }),
          _c("van-search", {
            attrs: { clearable: "", shape: "round" },
            on: {
              input: function ($event) {
                return _vm.treeSearch($event, _vm.$refs.approverTree)
              },
            },
            model: {
              value: _vm.approver.filterText,
              callback: function ($$v) {
                _vm.$set(_vm.approver, "filterText", $$v)
              },
              expression: "approver.filterText",
            },
          }),
          _c(
            "div",
            { staticClass: "h-vh-50", staticStyle: { "overflow-y": "auto" } },
            [
              _c(
                "div",
                { staticClass: "p-10" },
                [
                  _c("el-tree", {
                    ref: "approverTree",
                    attrs: {
                      "node-key": "uuid",
                      "check-strictly": "",
                      data: _vm.approver.data,
                      "filter-node-method": _vm.filterNode,
                      "check-on-click-node": "",
                      "show-checkbox": "",
                    },
                    on: {
                      "check-change": function ($event) {
                        return _vm.approverCheckChange(
                          $event,
                          _vm.$refs.approverTree
                        )
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }